import { render } from "./CRMRecordDatatableActions.vue?vue&type=template&id=a3152f20&scoped=true"
import script from "./CRMRecordDatatableActions.vue?vue&type=script&lang=js"
export * from "./CRMRecordDatatableActions.vue?vue&type=script&lang=js"

import "./CRMRecordDatatableActions.vue?vue&type=style&index=0&id=a3152f20&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3152f20"]])

export default __exports__